<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item> </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      filters: {}
    };
  },
  created() {}
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: right;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
}
</style>
